import axios from "axios";
import { create } from "zustand";

const usersStore = create((set) => ({
  allUser: null,
  isLoading: true,

  userFilterApply: 0,

  setUserFilterApply: ({ value }) => {
    set({ userFilterApply: value });
  },

  fetchAllUsers: async () => {
    try {
      // Fetch user
      const res = await axios.get("/fetch-all-users");

      // set user to state
      if (res.data.allUser.length) {
        set({ allUser: res.data.allUser });
      } else {
        set({ allUser: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default usersStore;
